import React, { useEffect, useMemo } from "react";
import { Route, Routes, useLocation } from "react-router";
import { AcquireLogin } from "./components";
import { AppLayout } from "@/layouts";
import {
  authLayoutRoutes,
  errorRoutes,
  generalRoutes,
  redirectRoutes,
  secureGeneralRoutes,
  rootRoutes,
} from "./";
import ReactGA from "react-ga4";
import { useUser } from "../providers";

/**
 * AppRoutes component that defines the main application routes.
 */
export const AppRoutes: React.FC = () => {
  const location = useLocation();
  const { user } = useUser();
  const hasCompanies = useMemo(() => {
    return !!(user?.currentCustomerKey || user?.currentTeam);
  }, [user?.currentCustomerKey, user?.currentTeam]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
    });
  }, [location.pathname]);

  return (
    <>
      <Routes>
        {redirectRoutes(hasCompanies)}
        {errorRoutes}
        {authLayoutRoutes}
        {generalRoutes}
        <Route element={<AcquireLogin />}>
          {secureGeneralRoutes}
          <Route element={<AppLayout />}>
            {/* {appLayoutGeneralRoutes} */}
            <Route path="/">{rootRoutes}</Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
};
